import {BlockUIEventType} from './block-ui-event-type.enum';

export class BlockUIEvent {
  constructor(public type: BlockUIEventType) {}
}
